import { useEffect, useState } from 'react';
import Lenis from 'lenis';
import { MotionConfig, useReducedMotion } from 'framer-motion';
import { Toaster } from 'sonner';
import { Header } from './components/Header';
import { Hero, Marquee } from './components/Hero';
import { InsuranceSection } from './components/InsuranceSection';
import { AboutSection, ApproachSection } from './components/AboutSection';
import { QuoteSection } from './components/QuoteSection';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
import { LegalDialog } from './components/LegalDialog';
import './App.css';

export default function App() {
  const [selection, setSelection] = useState({ type: '', token: 0 });
  const [legal, setLegal] = useState(null);
  const reduced = useReducedMotion();
  useEffect(() => {
    if (reduced) return;
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true, anchors: { offset: -90 }, autoRaf: true, prevent: node => node.hasAttribute('data-lenis-prevent') });
    return () => lenis.destroy();
  }, [reduced]);
  const onQuote = (type = '') => {
    setSelection({ type: typeof type === 'string' ? type : '', token: Date.now() });
    document.getElementById('devis')?.scrollIntoView({ behavior: reduced ? 'instant' : 'smooth', block: 'start' });
  };
  return <MotionConfig reducedMotion="user"><a href="#main-content" className="skip-link" data-testid="skip-to-content">Aller au contenu</a><Header onQuote={() => onQuote()} /><main id="main-content"><Hero onQuote={() => onQuote()} /><Marquee /><InsuranceSection onQuote={onQuote} /><AboutSection /><ApproachSection onQuote={onQuote} /><QuoteSection selection={selection} onPrivacy={() => setLegal('privacy')} /><FAQSection /></main><Footer onLegal={setLegal} /><LegalDialog type={legal} onClose={() => setLegal(null)} /><Toaster position="bottom-center" theme="dark" toastOptions={{ style: { background: '#191917', border: '1px solid #b8a16c', color: '#faf8f2' } }} /></MotionConfig>;
}